import { schema } from 'normalizr'

const User = new schema.Entity('User'),
	  Users = [User]

export default {
	User,
	Users
}
